import * as React from 'react'
import { cn } from '@/lib/utils'

export interface FloatingInputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	label: string
}

const FloatingInput = React.forwardRef<HTMLInputElement, FloatingInputProps>(
	({ className, type, label, id, ...props }, ref) => {
		const inputId = id || `floating-${label.toLowerCase().replace(/\s+/g, '-')}`

		return (
			<div className="relative">
				<input
					type={type}
					id={inputId}
					className={cn(
						'peer w-full h-14 px-4 pt-5 pb-2 rounded-lg border bg-[#2F2F32] border-[#4C4C4C] text-[#ffffff] text-base',
						'placeholder-transparent',
						'focus:outline-none focus:ring-2 focus:ring-[#EF4444] focus:border-transparent',
						'disabled:cursor-not-allowed disabled:opacity-50',
						'transition-colors',
						className
					)}
					placeholder={label}
					ref={ref}
					{...props}
				/>
				<label
					htmlFor={inputId}
					className={cn(
						'absolute left-4 text-[#888888] transition-all duration-200 pointer-events-none',
						'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-base',
						'peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs peer-focus:text-[#BABABB]',
						'top-2 -translate-y-0 text-xs',
						// When input has value (not placeholder-shown)
						'peer-[:not(:placeholder-shown)]:top-2 peer-[:not(:placeholder-shown)]:-translate-y-0 peer-[:not(:placeholder-shown)]:text-xs'
					)}
				>
					{label}
				</label>
			</div>
		)
	}
)
FloatingInput.displayName = 'FloatingInput'

export { FloatingInput }
